import { getRequestContext } from '../ssr-bridge/index.js';
import { isServer } from '../utils/index.js';
/**
 * Get an object representing all the cookies. Keys are the cookie names. Values
 * are the cookie values decoded with decodeURIComponent.
 */
export function getCookies() {
    if (isServer()) {
        return getRequestContext()?.cookies || {};
    }
    const cookies = {};
    document.cookie.split(/;\s?/).forEach(cookie => {
        const { name, value } = extractValue(cookie);
        cookies[name] = value;
    });
    return cookies;
}
/**
 * Read the persisted value from a cookie.
 */
export function getCookieData(name) {
    const cookies = getCookies();
    const rawValue = cookies[name];
    if (!rawValue) {
        return undefined;
    }
    try {
        return JSON.parse(rawValue);
    }
    catch (err) {
        return null;
    }
}
/**
 * Set a cookie
 *
 * @description
 * Note that the value will be URI encoded before it is written to the cookie.
 */
export function setCookie(name, value, attribs = {}) {
    const attribValues = Object.entries(attribs).map(([k, v]) => (typeof v == 'string' ? `${k}=${v}` : k));
    const cookie = [value, ...attribValues].join('; ');
    if (isServer()) {
        const serverContext = getRequestContext();
        if (serverContext) {
            serverContext.cookies[name] = cookie;
            serverContext['set-cookies'].set(name, cookie);
        }
        return;
    }
    document.cookie = `${name}=${cookie}`;
}
/**
 * Set a cookie
 *
 * @description
 * Note that the value will be URI encoded before it is written to the cookie.
 */
export function setCookieData(name, data, attribs = {}) {
    setCookie(name, JSON.stringify(data), attribs);
}
/**
 * Delete a cookie from browser
 */
export function deleteCookie(name) {
    const value = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    if (isServer()) {
        const serverContext = getRequestContext();
        if (serverContext) {
            delete serverContext.cookies[name];
            serverContext['set-cookies'].set(name, value);
        }
        return;
    }
    document.cookie = value;
}
function extractValue(cookieStr) {
    // only split on the first `=` char as the value can contain it as well
    const valueIdx = cookieStr.indexOf('=');
    const name = cookieStr.substring(0, valueIdx);
    const rawValue = cookieStr.substring(valueIdx + 1);
    const value = decodeUri(rawValue);
    return {
        name,
        value,
    };
}
// Avoid breaking the application in case of malformed cookies
function decodeUri(value) {
    try {
        return decodeURIComponent(value);
    }
    catch (e) {
        return value;
    }
}
//# sourceMappingURL=cookies.js.map